module.exports = __webpack_public_path__ + "img/42.0ac0a7e7.png";